export default __webpack_public_path__ + "static/media/instagramIcon.e3c1eb64.png";